export const ASC = 'asc'
export const DESC = 'desc'
export const DEFAULT = 'default'
